import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { AppState } from '@store/slices/generic.slice'
import {
  AIMetadataAdapterExport,
  AIMetadataModel,
} from '@store/slices/aiMeta.slice'
import {
  approveOutline,
  fetchAllMetadataBySlotIds,
} from '@store/thunk/aimeta.thunk'

export const aiMetaExtraReducers = (
  builder: ActionReducerMapBuilder<AppState<AIMetadataModel>>
) => {
  builder
    /// Approve outline
    .addCase(approveOutline.pending, (state, action) => {
      state.inProgress = [action.meta.arg.aimetaId, ...state.inProgress]
      state.error = null
    })
    .addCase(approveOutline.fulfilled, (state, action) => {
      state.inProgress = state.inProgress.filter(
        (id) => id !== action.meta.arg.aimetaId
      )
      AIMetadataAdapterExport.upsertOne(state, action.payload)
      state.loading = false
    })
    .addCase(approveOutline.rejected, (state, action) => {
      state.inProgress = state.inProgress.filter(
        (id) => id !== action.meta.arg.aimetaId
      )
      state.error = `Potvrzeni outlinu ${action.meta.arg.aimetaId} se nepovedlo`
    })
    /// Fetch all metadata by slot ids
    .addCase(fetchAllMetadataBySlotIds.pending, (state) => {
      state.loading = true
      state.error = null
    })
    .addCase(fetchAllMetadataBySlotIds.fulfilled, (state, action) => {
      AIMetadataAdapterExport.upsertMany(state, action.payload)
      state.loading = false
    })
    .addCase(fetchAllMetadataBySlotIds.rejected, (state) => {
      state.loading = false
      state.error = `Nepovedlo se stáhnout metadata podle listu slotů`
    })
}
